import React, { useState, useEffect } from "react";
import { Button, Box, Typography, LinearProgress, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const getNavProps = () => {
  let navProps = [];
  for (let prop in window.navigator) {
    navProps.push({ [prop]: window.navigator[prop] });
  }
  return { navProps, navPropsLength: navProps.length };
};

const PollComponent = () => {
  const [pollData, setPollData] = useState(null);
  const [guestId, setGuestId] = useState(null);
  const [pollResults, setPollResults] = useState(null);
  const [hasVoted, setHasVoted] = useState(false);
  const [userVote, setUserVote] = useState(null);
  const [n, setN] = useState(0);

  const fetchGuestId = async () => {
    try {
      const navProps = getNavProps();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/guest-info`,
        navProps
      );
      console.log(response.data.guestId);
      setGuestId(response.data.guestId);
    } catch (error) {
      console.error("Error fetching request stats: ", error);
    }
  };

  const fetchPoll = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const date = urlParams.get("date") || "2023-12-28"; // Replace "default-date" with a suitable default

      console.log(urlParams, date);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-poll`,
        { params: { date } }
      );
      console.log(response.data.poll);
      setPollData(response.data.poll);
    } catch (error) {
      console.error("Error fetching request stats: ", error);
    }
  };

  const submitVote = async (response) => {
    if (guestId && pollData && pollData.id) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/submit-vote`,
          {
            pollId: pollData.id,
            guestId,
            response,
          }
        );
        console.log(res.data);
        setHasVoted(true);
        setUserVote(response);
        fetchPollResults(pollData.id);
      } catch (error) {
        console.error("Error submitting vote: ", error);
      }
    }
  };

  const fetchPollResults = async (pollId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-votes`,
        {
          params: {
            pollId,
          },
        }
      );
      console.log(response.data);
      setPollResults(response.data);

      const sumValues = (obj) =>
        Object.values(obj).reduce((a, b) => a + Number(b), 0);
      setN(sumValues(response.data));
    } catch (error) {
      console.error("Error fetching request stats: ", error);
    }
  };

  const hasVotedBefore = async (pollId, guestId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/voted-status`,
        {
          pollId,
          guestId,
        }
      );
    } catch (error) {
      console.log("hasVotedBefore error");
      console.error("Error fetching request stats: ", error);
      setHasVoted(true);
      setUserVote(error.response?.data?.vote);
    }
  };

  useEffect(() => {
    fetchGuestId().then((res) => {
      fetchPoll();
    });
  }, []);

  useEffect(() => {
    if (pollData && pollData.id) {
      fetchPollResults(pollData.id);
    }
  }, [pollData]);

  useEffect(() => {
    if (pollData && pollData.id) {
      hasVotedBefore(pollData.id, guestId);
    }
  }, [pollData, guestId]);

  useEffect(() => {
    console.log("hasVoted", hasVoted);
    console.log("userVote", userVote);
  }, [hasVoted, userVote]);

  const getTotalVotes = () => {
    return Object.values(pollResults).reduce(
      (total, numVotes) => total + Number(numVotes),
      0
    );
  };

  const calculatePercentage = (response) => {
    const totalVotes = getTotalVotes();
    return totalVotes > 0 ? (pollResults[response] / totalVotes) * 100 : 0;
  };

  if (!pollData) return <div>Loading poll...</div>;

  const ProgressBarWithCheckmark = ({ response }) => (
    <Box position="relative" width="100%" mr={2}>
      <LinearProgress
        variant="determinate"
        value={calculatePercentage(response)}
        sx={{
          flexGrow: 1,
          height: 26,
          borderRadius: 10,
          backgroundColor: "#EAEEF3",
          "& .MuiLinearProgress-bar": {
            borderRadius: 10,
            // position: "relative",
            // zIndex: 1,
          },
        }}
      />
      {userVote === response && (
        <CheckCircleIcon
          color="success"
          sx={{
            position: "absolute",
            right: 15,
            top: "50%",
            transform: "translateY(-50%) translateX(50%)", // Adjust position inside the bar
            zIndex: 2, // Ensure it's above the progress bar
            width: 20,
            height: 20,
            color: "black",
          }}
        />
      )}
    </Box>
  );

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={6} lg={4}>
        <Box width="100%">
          <Typography variant="h6" align="center">
            {pollData.question}
          </Typography>
          {!hasVoted && pollData.possible_responses ? (
            <Box mt={2} textAlign="center">
              {pollData.possible_responses.map((option, index) => (
                <Button
                  key={index}
                  variant="contained"
                  color="primary"
                  onClick={() => submitVote(option)}
                  sx={{ mr: 1, mb: 1 }}
                >
                  {option}
                </Button>
              ))}
            </Box>
          ) : null}
          {hasVoted && pollResults && (
            <Box mt={2}>
              {Object.keys(pollResults).map((response, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1.5}>
                  <Typography variant="body1" sx={{ width: "70px" }}>
                    {response}
                  </Typography>
                  <ProgressBarWithCheckmark response={response} />
                  <Typography variant="body1">{`${Math.round(
                    calculatePercentage(response)
                  )}%`}</Typography>
                </Box>
              ))}
            </Box>
          )}
          <Typography variant="subtitle1" align="right" sx={{ color: "gray" }}>
            {n} votes
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default PollComponent;

{
  /* <LinearProgress
variant="determinate"
value={calculatePercentage(response)}
sx={{
  flexGrow: 1,
  mx: 1,
  height: 26,
  borderRadius: 10,
  backgroundColor: "#EAEEF3",
  "& .MuiLinearProgress-bar": {
    borderRadius: 0, // Ensure the bar itself also has rounded edges
  },
  // "& .MuiLinearProgress-bar": {
  //   backgroundColor:
  //     response === "Yes"
  //       ? "green"
  //       : response === "No"
  //       ? "red"
  //       : "primary.main",
  // },
}}
/> */
}
